import { MakeCall } from '@ha/api/v2/createMakeCall';

const acceptPaymentPlan =
  (makeCall: MakeCall) =>
  (paymentPlanToken: string): Promise<{ status: number }> =>
    makeCall<undefined>('POST', '/api/v1/plans/accept', {
      data: { token: paymentPlanToken },
    });
export { acceptPaymentPlan };
